import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950" />
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'radial-gradient(circle at 30% 50%, oklch(0.68 0.20 20 / 0.3) 0%, transparent 50%), radial-gradient(circle at 70% 30%, oklch(0.65 0.21 60 / 0.25) 0%, transparent 50%)',
      }} />

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[55%] flex flex-col items-start text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-4 md:mb-6 whitespace-nowrap">
              <i className="ri-fire-line text-sm" />
              实时更新 · 每日200+新鲜爆料
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-3 md:mb-4">
              {siteInfo.name}<br />
              <span className="text-primary-400">最新最全的吃瓜爆料平台</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-background-50/70 italic mb-5 md:mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mb-6 md:mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-6 md:mb-8">
              {siteInfo.heroStats.map((stat, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{stat.value}</span>
                  <span className="text-xs md:text-sm text-background-50/50">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line" />
                立即吃瓜
              </a>
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-line" />
                最新快讯
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20showing%20a%20dramatic%20warm-toned%20abstract%20composition%20with%20overlapping%20newspaper%20clippings%20and%20digital%20screens%20displaying%20entertainment%20news%2C%20with%20warm%20orange%2C%20deep%20red%2C%20and%20gold%20accents%20on%20a%20dark%20background%2C%20modern%20magazine%20editorial%20style%2C%20sophisticated%20and%20dramatic%20mood&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                alt="黑料吃瓜在线 - 娱乐八卦热点聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}